import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeSharedGlobal(): Provider {
  return provideTranslocoScope({
    scope: 'global',
    loader: i18nLoader,
  });
}
